import {createApp} from 'vue';
import App from './App.vue';
import router from './base/cabRouter.js';
import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-500.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/inter/latin-700.css';
import './assets/tokens.css';
import './assets/main.css';

const app = createApp(App);

app.use(router);
app.mount('#app');
